import { render, staticRenderFns } from "./WesQuestionPanel.vue?vue&type=template&id=a9da74ba&scoped=true"
import script from "./WesQuestionPanel.vue?vue&type=script&lang=js"
export * from "./WesQuestionPanel.vue?vue&type=script&lang=js"
import style0 from "./WesQuestionPanel.vue?vue&type=style&index=0&id=a9da74ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9da74ba",
  null
  
)

export default component.exports